import en from './en.json';
import fr from './fr.json';

export const translate = (key: string, language: string): string => {
    let langData: { [key: string]: string } = {};

    if (language === 'EN') {
        langData = en;
    } else if (language === 'FR') {
        langData = fr;
    }

    return langData[key];
};

export const translateNumber = (key: string, language: string): string => {
    let langData: { [key: string]: string } = {};
    if (!key) return '';
    if (key.includes('-')) return key;

    if (language === 'EN') {
        langData = en;
        return langData[key] || `${key}th`;
    }

    langData = fr;
    return langData[key] || `${key}ième`;
};
